<script setup lang="ts">
import { computed } from 'vue';
import { type CostStructure } from '@/api/patient-monthly-metrics';
import { formatCurrency } from '@/utils/currency';

const props = defineProps<{
  costs: CostStructure;
  selectedMonthText: string;
}>();

const showRetention = computed(() => props.costs.retentionRate !== null);
</script>

<template>
  <v-card class="pa-4 h-100 d-flex flex-column">
    <div class="d-flex align-center justify-space-between flex-wrap ga-1 mb-1">
      <span class="text-subtitle-1 font-weight-bold">Estructura de Costos</span>
      <v-chip
        size="small"
        variant="tonal"
        label
      >
        Impacto Directo
      </v-chip>
    </div>
    <p class="text-caption text-medium-emphasis mb-3">
      Consolidación del costo incurrido según los tipos de contratación autorizados.
    </p>
    <v-card
      :elevation="1"
      class="pa-3 mb-3"
    >
      <div class="d-flex align-center justify-space-between flex-wrap ga-1">
        <span class="text-caption font-weight-bold text-error">
          Costo Bruto Honorarios
        </span>
        <span
          v-if="showRetention"
          class="text-caption text-medium-emphasis"
        >
          (Sujeto a retención)
        </span>
      </div>
      <div class="text-h6 font-weight-bold text-error">
        {{ formatCurrency(costs.professionalFeesCost) }}
      </div>
    </v-card>
    <v-card
      :elevation="1"
      class="pa-3 mb-3"
    >
      <div class="d-flex align-center justify-space-between flex-wrap ga-1">
        <span class="text-caption font-weight-bold">Costo Contratados</span>
        <span class="text-caption text-medium-emphasis">(Proporcional)</span>
      </div>
      <div class="text-h6 font-weight-bold">
        {{ formatCurrency(costs.salaryBasedCost) }}
      </div>
    </v-card>
    <v-card
      variant="tonal"
      color="primary"
      class="pa-3 mb-3"
    >
      <div class="d-flex align-center justify-space-between flex-wrap ga-1">
        <span class="text-caption font-weight-bold">Costo Directo Total</span>
        <span class="text-caption">(Honorarios + Contratados)</span>
      </div>
      <div class="text-h6 font-weight-bold">
        {{ formatCurrency(costs.totalDirectCost) }}
      </div>
    </v-card>
    <p class="text-caption text-medium-emphasis mb-0 mt-auto">
      <v-icon
        icon="mdi-file-document-outline"
        size="x-small"
      />
      Consolidado correspondiente a {{ selectedMonthText }}.
    </p>
  </v-card>
</template>
